import React, { useEffect } from 'react';
import 'react-dates/initialize';
import { AppRouter } from '../router';
import { BrowserRouter as Router } from 'react-router-dom';
// require('../services');
import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/app.scss';
import 'react-dates/lib/css/_datepicker.css';
import ReactNotification from 'react-notifications-component';
import { mapDispatchToProps as menuActions } from 'actions/menu';
import { connect } from 'react-redux';
import { getWindowDimensions } from 'utils';

function App(props) { 
  
  useEffect(()=>{
    if(getWindowDimensions().width < 1100){
      props.closeMenu();
    }
  }, []);

  return (
    <Router>
      <div className="app">
        <div className="main">
          <ReactNotification />
          <AppRouter/>
        </div>
      </div>
    </Router>
  );
}

const ConnectedApp = connect(null, { ...menuActions })(App);

export { ConnectedApp };
